import './Input.css'

export default function Input({value, placeholder, onChange, name, type, label}){
    return <div>
            <label className="label" for={name}>
                {label} *
            </label>
            <input  
                id={name}
                type={type}
                name={name}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                className='input'
                required
                />
    </div>

}